import $ from "jquery";

window.$ = window.jQuery = $;

/**
 * Is a given element in the current viewpoint.
 *
 * @param el
 * @returns {boolean}
 */
function isElementInViewport( el ) {
	if ( typeof jQuery === "function" && el instanceof jQuery ) {
		el = el[ 0 ];
	}

	let rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
		rect.right <= ( window.innerWidth || document.documentElement.clientWidth )
	);
}

/**
 * Get the absolute value of a fraction of a number.
 *
 * @param number
 * @param iteration
 * @param count
 * @returns {number}
 */
function fraction( number = 42, iteration = 6, count = 7 ) {
	return Math.floor( number * ( iteration / count ) );
}

/**
 * Recursively animate a number.
 *
 * @param $el
 * @param iteration
 * @param iterations
 */
function animateNumber( $el, iteration = 0, iterations = 10 ) {
	let $number      = $( '.number', $el );
	let targetNumber = parseInt( $el.data( 'number' ) );

	$number.html( fraction( targetNumber, iteration, iterations ) );

	setTimeout(
		function () {
			if ( iteration < iterations ) {
				animateNumber( $el, ++iteration, iterations );
			}
			$el.data( 'animated', 1 );
		},
		66
	);

}

$( document ).ready(
	function () {
		let $numbers = $( '*[data-animate-number="1"]' );

		$( window ).on(
			'scroll',
			function () {
				setTimeout(
					function () {
						$numbers.each(
							function ( index, number ) {
								if ( isElementInViewport( number ) && $( number ).data( 'animated' ) == 0 ) {
									animateNumber( $( number ), 1, 50 );
								}
							}
						);
					},
					300
				);
			}
		);
	}
);
